
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-auto-apply",
      function () {
        return require("private-next-pages/ai-auto-apply/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-auto-apply"])
      });
    }
  